import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'
import api from '../api'
import { sendPageview, sendEvent } from '../analytics'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    stores: [],
    location: null,
    currentStore: null,
    product: null,
    categories: [],
    currentCategory: null,
    categoriesStack: [],
    products: [],
    loadingProducts: false,
    store: null,
    url: null,
    ...window.__PRELOADED_STATE__,
  },
  getters: {
    stores: (state) => state.stores,
    location: (state) => state.location,
    currentStore: (state) => state.currentStore,
    product: (state) => state.product,
    categories: (state) => state.categories,
    categoriesStack: (state) => state.categoriesStack,
    currentCategory: (state) => state.currentCategory,
    products: (state) => state.products,
    loadingProducts: (state) => state.loadingProducts,
    store: (state) => state.store,
    url: (state) => state.url,
  },
  mutations: {
    [types.SELECT_PRODUCT] (state, product) {
      state.product = product
    },
    [types.CHOOSE_OTHER_PRODUCT] (state) {
      state.product = null
    },
    [types.SELECT_PLACE] (state, place) {
      state.location = {
        address: place.formatted_address,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
      }
    },
    [types.NAVIGATE_IN_CATEGORY] (state, category) {
      state.currentCategory = category
      state.categoriesStack.push(category)
    },
    [types.NAVIGATE_BACK_CATEGORIES] (state) {
      state.categoriesStack.splice(-1)
      state.products = []
      state.product = null
    },
    [types.LOAD_PRODUCTS] (state) {
      state.loadingProducts = true
    },
    [types.RECEIVE_PRODUCTS] (state, products) {
      state.products = products
      state.loadingProducts = false
    },
    [types.RECEIVE_STORES] (state, stores) {
      stores = _.map(stores, store => {
        store.openInfoWindow = false
        return store
      })
      state.stores = stores
    },
    [types.DELETE_PLACE] (state) {
      state.location = null
    },
    [types.SELECT_STORE] (state, store) {
      state.currentStore = store
      state.stores = _.map(state.stores, store => {
        Vue.set(store, 'openInfoWindow', (state.currentStore && store.ID === state.currentStore.ID))
        return store
      })
    },
  },
  actions: {
    selectProduct ({ commit, dispatch, state }, product) {
      commit(types.SELECT_PRODUCT, product)
      const productId = (state.product !== null) ? state.product.id : null
      const address = (state.location !== null) ? state.location.address : null
      const url = state.url + `?filter[product_id]=${productId}&q=${address}`
      history.pushState(null, null, url)
      sendPageview(url)
      dispatch('getStores')
    },
    chooseOtherProduct ({ commit }) {
      commit(types.CHOOSE_OTHER_PRODUCT)
    },
    selectPlace ({ commit, dispatch, state }, place) {
      commit(types.SELECT_PLACE, place)
      const productId = (state.product !== null) ? state.product.id : null
      const address = (state.location !== null) ? state.location.address : null
      const url = state.url + `?filter[product_id]=${productId}&q=${address}`
      history.pushState(null, null, url)
      sendPageview(url)
      dispatch('getStores')
    },
    navigateInCategory ({ commit, dispatch }, category) {
      commit(types.NAVIGATE_IN_CATEGORY, category)
      if (category.children.length === 0) {
        dispatch('getProducts', category.term_id)
      }
    },
    navigateBackCategories ({ commit }) {
      commit(types.NAVIGATE_BACK_CATEGORIES)
    },
    getProducts ({ commit }, categoryId) {
      commit(types.LOAD_PRODUCTS)
      api.getProductsInCategory(categoryId, (products) => {
        commit(types.RECEIVE_PRODUCTS, products)
      })
    },
    getStores({ commit, state }) {
      if (state.product) {
        api.getStoresForProduct(state.location, state.product.id, (stores) => {
          commit(types.RECEIVE_STORES, stores)
        })
      } else {
        api.getStores(state.location, (stores) => {
          commit(types.RECEIVE_STORES, stores)
        })
      }
    },
    selectStore({ commit }, store) {
      commit(types.SELECT_STORE, store)
      if (store) {
        sendEvent("Store", "View on map", store.ID)
      }
    }
  }
})
